// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2mnkk","comment":"styles_comment__2M4G-"};